import * as React from 'react'
import { useMemo } from 'react'
import useViewport, { Viewport } from '../../hooks/useViewport'
import { BaseOverviewHeaderItemProps, useOverviewStyles } from '../BaseOverview/BaseOverview'
import MoneyText from '../../components/Text/Currency/MoneyText'
import {
    BaseFixedPriceOverviewProps,
    ExtendedFixedPriceOverviewDto,
    FixedPriceFilterType,
    FixedPriceOverviewCount,
    FixedPriceSortingType,
    useItemStyles,
} from './BaseFixedPriceOverview'
import { useSettings } from '../../hooks/useSettings'
import useCurrencies from '../../hooks/useCurrencies'
import { Checkbox, Tooltip } from '@fluentui/react-components'
import { useTranslation } from 'react-i18next'

export default function FixedPriceHeaderItem(
    props: BaseOverviewHeaderItemProps<ExtendedFixedPriceOverviewDto, FixedPriceFilterType, FixedPriceSortingType, FixedPriceOverviewCount>,
) {
    const fixedPriceProps = props as unknown as BaseFixedPriceOverviewProps
    const fixedPriceStyles = useItemStyles()
    const overviewStyles = useOverviewStyles()
    const { settings } = useSettings()
    const { t: translate } = useTranslation()
    const { viewport, isViewport } = useViewport()
    const { getCurrency } = useCurrencies()

    const listItemSmall = useMemo<boolean>(() => isViewport('<', Viewport.XL), [viewport])

    if (listItemSmall) {
        return (
            <>
                {props.onAllItemsSelected && (
                    <>
                        <Checkbox
                            checked={props.isAllItemsSelected?.(props.items)}
                            disabled={!props.isAllItemsSelectable?.(props.items)}
                            onChange={(_, data) => props.onAllItemsSelected(data, props.items)}
                        />
                        <div>&nbsp;</div>
                    </>
                )}
                <div></div>
                <div></div>
                <div></div>
                <div className={fixedPriceStyles.listFixedPriceItemSmallBottomRow}>
                    <div></div>
                    <Tooltip relationship={'label'} content={translate('registration.rate')} withArrow>
                        <div>
                            {props.count.currencies?.map((currency, index) => (
                                <MoneyText key={index} amount={currency.turnover} currency={getCurrency(currency.currency)} align="right" />
                            ))}
                        </div>
                    </Tooltip>
                    {!fixedPriceProps.hideInvoiceField && (
                        <Tooltip relationship={'label'} content={translate('registration.turnover')} withArrow>
                            <div>
                                {props.count.currencies?.map((currency, index) => (
                                    <MoneyText
                                        key={index}
                                        amount={currency.invoiceTurnover}
                                        currency={getCurrency(currency.currency)}
                                        align="right"
                                    />
                                ))}
                            </div>
                        </Tooltip>
                    )}
                </div>
            </>
        )
    }

    return (
        <>
            {props.onAllItemsSelected && (
                <Checkbox
                    checked={props.isAllItemsSelected?.(props.items)}
                    disabled={!props.isAllItemsSelectable?.(props.items)}
                    onChange={(_, data) => props.onAllItemsSelected(data, props.items)}
                />
            )}
            <div></div>
            <div></div>
            <div></div>
            <div>
                <span className={overviewStyles.invisible}>
                    {settings?.fileReference?.prefix + ''.padEnd(settings?.fileReference?.length, '0') + settings?.fileReference?.suffix}
                </span>
            </div>
            <Tooltip relationship={'label'} content={translate('registration.rate')} withArrow>
                <div>
                    {props.count.currencies?.map((currency, index) => (
                        <MoneyText key={index} amount={currency.turnover} currency={getCurrency(currency.currency)} align="right" />
                    ))}
                </div>
            </Tooltip>
            {!fixedPriceProps.hideInvoiceField && (
                <Tooltip relationship={'label'} content={translate('registration.turnover')} withArrow>
                    <div>
                        {props.count.currencies?.map((currency, index) => (
                            <MoneyText key={index} amount={currency.invoiceTurnover} currency={getCurrency(currency.currency)} align="right" />
                        ))}
                    </div>
                </Tooltip>
            )}
        </>
    )
}
